__turbopack_context__.v({
  "capitalize": "zWvF-q_capitalize",
  "container": "zWvF-q_container",
  "navBar": "zWvF-q_navBar",
  "singleOption": "zWvF-q_singleOption",
});
